import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9dc602da&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=9dc602da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc602da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dc602da')) {
      api.createRecord('9dc602da', component.options)
    } else {
      api.reload('9dc602da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9dc602da&scoped=true&", function () {
      api.rerender('9dc602da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/intake/children/detail/components/components/PostCard/index.vue"
export default component.exports